import React from 'react';
import SidebarParametres from '../../../layout/SidebarParametres';
import { useOAD } from '../../../layout/OADLayout';

/**
 * Adaptation / Modification ITK.
 *
 * Page entièrement en construction (Q15) : la sidebar ne porte que la
 * navigation de niveau 3, sans la liste déroulante "ITK" du prototype.
 */
export default function ModificationITK() {
  const { idExploit } = useOAD();

  return (
    <div className="oad-contenu">
      <SidebarParametres
        niveau1="2035-2050"
        niveau2="adaptations"
        niveau3="itk"
        idExploit={idExploit}
      />
      <main className="oad-cards">
        <div className="oad-card oad-card-construction">
          <h2>Modification ITK</h2>
          <p>Cette page est en construction.</p>
        </div>
      </main>
    </div>
  );
}
